module.exports = {
  "country": "ES",
  "artist": "Sergio Dalma",
  "song": "Bailar Pegados",
  "year": "1994",
  "place": "4",
  "spotify": "4QkQmdvFjEVvjc1ONi6t6N"
};